import React from 'react';
import { colors } from '@styleseat/brand';
import { DismissParams } from '../types';
import { BodyText, Button } from '../../../../../ui';

export const DismissButton: React.FC<DismissParams> = ({
  testID,
  analyticsDismissData,
  onDismiss,
  onDismissClick,
  dismissText,
}) => {
  const handleDismiss = () => { onDismissClick(analyticsDismissData, onDismiss); };

  return (
    <Button
      appearance="none"
      size="small"
      onClick={handleDismiss}
      testID={testID}
    >
      <BodyText
        color={colors.metal}
        appearance="smaller-underline"
        textTransform="none"
      >
        {dismissText || 'Dismiss'}
      </BodyText>
    </Button>
  );
};
